import React from 'react';
import { connect } from 'react-redux';
import MenuLink from '../MenuLink';
import { validateCapability } from '@utils/helpers';

function ActionsSidebar(props) {
  const {
    trackEvent,
    authenticationReducer: { businessTokenData },
  } = props;

  const links = [];

  if (validateCapability(businessTokenData, 'MEDIA_APPROVAL')) {
    links.push({
      name: 'Approvals',
      icon: ['fal', 'check-double'],
      translator: 'APPROVALS',
      disabled: false,
      logger: () => trackEvent('click_approvals_sub_menu'),
    });
  }
  if (validateCapability(businessTokenData, 'FEED')) {
    links.push({
      name: 'Feed',
      icon: ['fa', 'list'],
      translator: 'FEED',
      disabled: false,
      logger: () => trackEvent('click_approvals_sub_menu'),
    });
  }

  return <MenuLink links={links} page="Medias" />;
}

function mapStateToProps(state) {
  return {
    authenticationReducer: state.authenticationReducer,
  };
}

export default connect(mapStateToProps)(ActionsSidebar);
